import { AssessmentType } from '@@types/api.types';
import { SuccessModal } from '@components/core/success-modal.component.tsx';
import { useSurveyNavigation } from '@hooks/surveys.hook';
import { queryClient } from '@queries/client';
import { queryKeys } from '@queries/keys';
import { useInnovatorCreateSurvey } from '@queries/survey.query';
import { useState } from 'react';

export const SuccessStep = (props: { onClose; technologyId: string; uses: { useId: string; domainId: string }[] }) => {
  const { technologyId, uses } = props;
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { navigateToSurvey } = useSurveyNavigation();

  const { mutateAsync: createSurvey } = useInnovatorCreateSurvey();
  const handleClose = () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.technology.getTechnologies });
    setIsModalOpen(false);
    props.onClose();
  };

  const handleContinue = async () => {
    const survey = await createSurvey({
      assessmentType: AssessmentType.TRL,
      technologyId,
      uses,
    });
    queryClient.invalidateQueries({ queryKey: queryKeys.technology.getTechnologies });
    navigateToSurvey(`/technology/${technologyId}/survey/${survey.id}`);
  };

  return (
    <SuccessModal
      continueMessage="Start TRL"
      isOpen={isModalOpen}
      onClose={handleClose}
      onContinue={handleContinue}
      title="Technology Created"
      text="You can now assess your technology to get a Technology Readiness Level (TRL) Score."
      width="400px"
    />
  );
};
